import axios from "axios";

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

const waNumber = process.env.REACT_APP_WHATSAPP_NUMBER || "5511999999999";
export const WHATSAPP_URL = `https://wa.me/${waNumber}?text=${encodeURIComponent(
  "Olá! Vim pelo site da Resolv e quero resolver uma demanda no meu imóvel."
)}`;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
